import { SIGNUP_TEXT } from "../../domain/constants/constants";
import { styles as s } from "../../styles/signupstyles";

type Props = {
  onHowItWorks: () => void;
};

export default function SignupHeader({
  onHowItWorks,
}: Props) {
  return (
    <>
      <div className={s.topLink}>
        <p className={s.topLinkText}>
          {SIGNUP_TEXT.newToTullu}{" "}
          <button
            className={s.topLinkButton}
            onClick={onHowItWorks}
          >
            {SIGNUP_TEXT.howItWorks}
          </button>
        </p>
      </div>

      <h2 className={s.title}>
        {SIGNUP_TEXT.title}
      </h2>

      <p className={s.subtitle}>
        {SIGNUP_TEXT.subtitle}
      </p>
    </>
  );
}